import * as React from 'react';
import styled from 'styled-components';
import { FaFacebook, FaLinkedin, FaTwitter } from 'react-icons/fa';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton, } from 'react-share';

const TwitterFacebookLinkedin = styled.div`
	display: flex;
	justify-content: space-between;
	min-width: 120px;
	max-width: 140px;
	margin-bottom: 1em;
	color: #313c46;

	& svg {
		height: 30px;
		width: 30px;
		opacity: 0.8;

		&:hover {
			cursor: pointer;
			opacity: 1;
		}
	}
`;

const ShareOnSocialMedia = ({mkNewsStoryURL, title}: any) => (
	<TwitterFacebookLinkedin>

		<TwitterShareButton
			title={title}
			url={mkNewsStoryURL}
		>
			<FaTwitter />
		</TwitterShareButton>

		<FacebookShareButton
			url={mkNewsStoryURL}
		>
			<FaFacebook />
		</FacebookShareButton>

		<LinkedinShareButton
			title={title}
			url={mkNewsStoryURL}
		>
			<FaLinkedin />
		</LinkedinShareButton>

	</TwitterFacebookLinkedin>
);

export default ShareOnSocialMedia;
